export const DRUPAL_DOMAIN = process.env.VUE_APP_DRUPAL_DOMAIN;
export const DRUPAL_API_VERSION_URL = process.env.VUE_APP_DRUPAL_API_VERSION_URL;
export const RAPI_DOMAIN = process.env.VUE_APP_RAPI_DOMAIN;
export const RAPI_VERSION_URL = process.env.VUE_APP_RAPI_VERSION_URL;
export const PSHINY_API_URL = 'https://pshiny.thinkbluedata.co';
